import { classNames } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, set } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type AppState from "cc-frontend/services/app-state"
import type Dragging from "cc-frontend/services/dragging"

@classNames("course-outline-with-detail__outline")
export default class Outline extends Component {
  // service
  @service("ember-store") store
  @service appState!: AppState
  @service dragging!: Dragging
  @service rpc

  //args
  onNewFocusedItemId!: Function
  focusedItemId!: string
  course!: Course
  rotationCalendar!: RotationCalendar
  planbook!: Planbook

  // args related to being able to select things
  isSelectable?: boolean
  onUnitSelect?: Function
  onLessonSelect?: Function
  selectedDateStrings?: Array<string>
  selectedUnitIds?: Array<string>

  // state
  hasNotYetScrolled = true
  hasQuery = false

  isSearching = false
  _previousFocusedItemId
  queryResults: Array<any> | null = null

  @action
  startedSearch(query) {
    this.set("hasQuery", query !== "" && query !== null)
    this.set("isSearching", true)
  }

  @action
  finishedSearch(data) {
    this.set("queryResults", data)
    this.set("isSearching", false)
  }

  @action
  onSearchFocus() {
    set(this, "_previousFocusedItemId", this.focusedItemId)
    this.onNewFocusedItemId(null)
  }

  @action
  onClearSearchQuery() {
    this.set("queryResults", null)
    this.onNewFocusedItemId(this._previousFocusedItemId)
  }
}
